module.exports = __webpack_public_path__ + "img/logo.7a9973e1.svg";